import {REPORT_NEW_FRONTLINE_CLIENTS} from '/enum/records.enum';

export default {
  reportName: REPORT_NEW_FRONTLINE_CLIENTS,
};
